import arrayUtils from '../../static/js/arrayUtils'
let queryParamterShowUtils = {}

/**
  获取需要转换后的显示的查询内容
  @param {object} 真实数据，
  @param {object} 输入组件定义
*/
var getParamterShowValue = function (value, criteriaFormDefData) {
  // console.log("queryParamterShowUtils.getParamterShowValue", value,
  //   criteriaFormDefData);
  if (criteriaFormDefData.parameter) {
    var options =
      criteriaFormDefData.parameter.options ||
      (Array.isArray(criteriaFormDefData.parameter.source)
        ? criteriaFormDefData.parameter.source
        : null)

    if (options && options.length > 0) {
      var valueField = 'value'
      var labelField = 'label'
      if (options[0] && options[0].hasOwnProperty('code')) {
        valueField = 'code'
      }
      if (options[0] && options[0].hasOwnProperty('name')) {
        labelField = 'name'
      }

      let temoVal = value
      if (typeof value === 'boolean' && typeof options[0][valueField] === 'string') {
        temoVal = value + ''
      }

      var returnData = arrayUtils.getArrayItemByFieldValue(options, valueField, temoVal)

      // console.log("queryParamterShowUtils.getParamterShowValue.returnData",
      //   valueField, labelField,
      //   returnData);

      if (returnData) return returnData[labelField]
    } else if (
      criteriaFormDefData?.parameter?.valueIsObject ||
      criteriaFormDefData?.parameter?.valueIsObj
    ) {
      return value.name
    }
  }
  return value
}
/**
    获取需要转换后的显示的查询内容
    @param {object} 真实数据， String，或数组。
    @param {object} 输入组件定义
  */
queryParamterShowUtils.getParamterShowValue = function (value, criteriaFormDefData) {
  if (value === '' || value === null || value == undefined) return value
  if (Array.isArray(value)) {
    var tmpArray = []
    value.forEach(function (v) {
      var returnString = getParamterShowValue(v, criteriaFormDefData)
      if (returnString) tmpArray.push(returnString)
    })
    if (criteriaFormDefData?.component?.code === 'panguDatePicker') {
      return tmpArray.join('~')
    }
    return tmpArray.join(',')
  }

  return getParamterShowValue(value, criteriaFormDefData)
}

export default queryParamterShowUtils
